import { IResponsePinCheck, IResponseSms, IResponseUniquePhone, IResponseUser } from '../entities/user';

/**
 * 유저 entity 변환 함수
 *
 * @export
 * @param {any} resData
 * @return {*}  {IUser}
 */
// eslint-disable-next-line
export function mapUser(resData: any): IResponseUser {
  const ret: IResponseUser = {
    id: resData.id,
    password: resData.password,
    phone: resData.phone,
    name: resData.name,
    passwordRetryCount: resData.passwordRetryCount,
    status: resData.status,
    trx_address: resData.trx_address,
    balance: {
      address: resData.balance.address,
      trxBalance: resData.balance.trxBalance,
      trxKRW: resData.balance.trxKRW,
      tokenBalance: resData.balance.tokenBalance,
      tokenKRW: resData.balance.tokenKRW,
      dbsBuyCount: resData.balance.dbsBuyCount,
      dbsBuyCountKRW: resData.balance.dbsBuyCountKRW,
    },
    pin: resData.pin,
    errorCount: resData.errorCount,
    lastLoginTime: resData.lastLoginTime,
  };

  return ret;
}

/**
 * sms entity 변환 함수
 *
 * @export
 * @param {any} resData
 * @return {*}  {ISms}
 */
// eslint-disable-next-line
export function mapSms(resData: any): IResponseSms {
  const ret: IResponseSms = {
    authNumber: resData.authNumber,
  };

  return ret;
}

/**
 *
 *
 * @export
 * @param {*} resData
 * @return {*}  {IResponseUniquePhone}
 */
// eslint-disable-next-line
export function mapUniqueNumber(resData: any): IResponseUniquePhone {
  const ret: IResponseUniquePhone = {
    isUnique: resData,
  };

  return ret;
}

/**
 *
 * @param resData
 * @returns
 */
// eslint-disable-next-line
export function mapPinCheck(resData: any): IResponsePinCheck {
  const ret: IResponsePinCheck = {
    success: textToBoolean(resData),
  };

  return ret;
}

function textToBoolean(text: string): boolean {
  if (text === 'isMatched') return true;
  if (text === 'isNotMatched') return false;

  return false;
}
